export default {"src":"/_next/static/media/user.31a1a86b.svg","height":16,"width":16};